import type { MutedAlertState } from '@kirin/api-client/contracts/alerts';

import { formatUtcDate, formatUtcDateTime } from '@/lib/date-utils';

/**
 * Build the three text rows shown in the muted-alert tooltip from a
 * {@link MutedAlertState}. Returns `null` when the alert is not muted, so
 * callers can early-return instead of rendering the tooltip.
 *
 * Both date fields are rendered in **UTC** (see {@link formatUtcDateTime} /
 * {@link formatUtcDate} for the rationale). `mutedUntil === null` means an
 * indefinite mute and is surfaced as the literal string `"Indefinite"`.
 */
export function formatMutedTooltipLines(
  mute: MutedAlertState | null | undefined
): { muter: string; mutedAt: string; mutedUntil: string } | null {
  if (!mute?.muted) return null;
  const muter = mute.mutedByName ?? mute.mutedByEmail ?? 'Unknown user';
  const mutedAt = formatUtcDateTime(mute.mutedAt);
  const mutedUntil = mute.mutedUntil
    ? formatUtcDate(mute.mutedUntil)
    : 'Indefinite';
  return { muter, mutedAt, mutedUntil };
}
